import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PWAProvider } from "./auth/PWAContext";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import { registerSW } from './registerServiceWorker';
registerSW();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <PWAProvider>
    <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
    </PWAProvider>
  </React.StrictMode>
);

